export const SERVICES_INFO_MODAL_SIZE = 25;
export const SERVICE_INFO_URL_QUERY_PARAM = '?mobile-view=true';
